import axios from 'axios';
import { FjernInnkBulkResult, InnkAutoSyncRunDto, InnkjopPreviewResultDto } from './types';
import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/innkjop-sync';

async function getPreview(fraOgMedDatoFilter?: string): Promise<InnkjopPreviewResultDto> {
  const response = await axios.get(`${baseUrl}/preview`, {
    params: { fraOgMedDatoFilter },
  });
  return response.data;
}

async function getFakturaDetaljer(
  statistikknr: number,
  fraDato?: string,
  tilDato?: string,
): Promise<unknown> {
  const response = await axios.get(`${baseUrl}/fakturadetaljer/${statistikknr}`, {
    params: { fraDato, tilDato },
  });
  return response.data;
}

async function getFakturaSammendrag(
  statistikknr: number,
  fraDato?: string,
  tilDato?: string,
): Promise<unknown> {
  const response = await axios.get(`${baseUrl}/fakturasammendrag/${statistikknr}`, {
    params: { fraDato, tilDato },
  });
  return response.data;
}

async function fjernInnkBulk(enhetIds: number[]): Promise<FjernInnkBulkResult> {
  const response = await axios.post(`${baseUrl}/fjern-innk-bulk`, { enhetIds });
  return response.data;
}

async function leggTilInnkBulk(
  items: Array<{ enhetId: number; fraOgMedDato: Date }>,
): Promise<number> {
  const response = await axios.post(`${baseUrl}/legg-til-innk-bulk`, { items });
  return response.data;
}

async function getAutoSyncRuns(take = 30): Promise<InnkAutoSyncRunDto[]> {
  const response = await axios.get(`${baseUrl}/auto-sync-runs`, {
    params: { take },
  });
  return response.data;
}

const InnkjopSyncApi = {
  getPreview,
  getFakturaDetaljer,
  getFakturaSammendrag,
  fjernInnkBulk,
  leggTilInnkBulk,
  getAutoSyncRuns,
};

export default InnkjopSyncApi;
